export const updateArray = (array, entry, add) => {
  const indexOfEntry = array.indexOf(entry)

  if (indexOfEntry > -1) {
    if (!add) {
      array.splice(indexOfEntry, 1)
    }
  } else {
    if (add) {
      array.push(entry)
    }
  }
}

export const basicSort = (targetArray, sortOrderArray, ascending) => {
  return targetArray.sort(
    (a, b) =>
      sortOrderArray.indexOf(ascending ? a : b) -
      sortOrderArray.indexOf(ascending ? b : a)
  )
}

export const updateArrayWithNewItem = (
  arrayOfObjects,
  newObject,
  comparisonKey,
  deleteObject = false
) => {
  const newArrayOfObjects = [...arrayOfObjects]
  const index = newArrayOfObjects.findIndex(
    (obj) => obj[comparisonKey] === newObject[comparisonKey]
  )
  if (deleteObject) {
    newArrayOfObjects.splice(index, 1)
  } else {
    if (index === -1) {
      newArrayOfObjects.push(newObject)
    } else {
      newArrayOfObjects[index] = newObject
    }
  }

  return newArrayOfObjects
}
/*
 * This method is a generic find method where we get back the first object in an array when a match is found.
 * */
//TODO: Need to add type check, Use only if arrayList, comparisonKey, comparisonValue has proper types
export const findItemByItsPropertyValue = (
  arrayList,
  comparisonKey,
  comparisonValue,
  comparisonOperator = '==='
) => {
  return arrayList.find((item) => {
    const booleanValueAfterComparison = compare(
      item[comparisonKey],
      comparisonValue,
      comparisonOperator
    )
    return booleanValueAfterComparison
  })
}
/*
 * To compare between two operands using a comparison operator, we can call this method `compare`.
 * */
export function compare(operand1, operand2, comparisonOperator) {
  switch (comparisonOperator) {
    case '===':
      return operand1 === operand2
    case '==':
      return operand1 == operand2
    case '!==':
      return operand1 !== operand2
    case '!=':
      return operand1 != operand2
    case '>':
      return operand1 > operand2
    case '>=':
      return operand1 >= operand2
    case '<':
      return operand1 < operand2
    case '<=':
      return operand1 <= operand2
    default:
      return operand1 === operand2
  }
}
